
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Group 7927","xmlns":"http://www.w3.org/2000/svg","width":"44","height":"44"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 6308"}},[_c('g',{attrs:{"data-name":"Group 6307"}},[_c('g',{attrs:{"data-name":"Group 5947","transform":"translate(4 4)","fill":"none","stroke":"#109a50"}},[_c('circle',{attrs:{"data-name":"Ellipse 496","cx":"18.5","cy":"18.5","r":"18.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('circle',{attrs:{"data-name":"Ellipse 497","cx":"18.5","cy":"18.5","r":"18.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"data-name":"Line 107","stroke-linecap":"round","stroke-linejoin":"round","d":"M18.696 8.889V16.5"}}),_c('path',{attrs:{"data-name":"Line 108","stroke-linecap":"round","stroke-linejoin":"round","d":"M28.111 18.304H20.5"}}),_c('circle',{attrs:{"data-name":"Ellipse 498","cx":"1.5","cy":"1.5","r":"1.5","transform":"translate(17 17)","stroke-miterlimit":"10"}})])]),_c('path',{attrs:{"data-name":"Rectangle 4208","fill":"none","d":"M0 0h44v44H0z"}})])])
          )
        }
      }
    